import { EquipmentListItemPrice, EquipmentListItemText } from './style'
import { Icon } from 'shared/components/Icons'
import { AreaNomenclature } from 'features/Areas/model/initialValues'

interface EquipmentListItemProps {
    equipment: AreaNomenclature
    isEditable: boolean
    index: number
    remove: <X = any>(index: number) => X | undefined
}

export function EquipmentListItem({
    equipment,
    isEditable,
    index,
    remove,
}: EquipmentListItemProps) {
    function handleDeleteListItem() {
        remove(index)
    }

    const isCountMoreThanOne = equipment.count > 1
    const equipmentCount = isCountMoreThanOne ? `(x${equipment.count})` : ''
    const equipmentPrice = `₽ ${equipment.price}`

    return (
        <EquipmentListItemText>
            {equipment.name} {equipmentCount}
            {'\u00A0'}
            <EquipmentListItemPrice>{equipmentPrice}</EquipmentListItemPrice>
            {'\u00A0'}{' '}
            {isEditable && (
                <Icon
                    as='button'
                    type='button'
                    name='clearInput'
                    onClick={handleDeleteListItem}
                />
            )}
        </EquipmentListItemText>
    )
}
